import { BehaviorSubject } from "rxjs";
import Cookies from "js-cookie";
const apiCalls = require("../ApiCalls")

const currentUserSubject = new BehaviorSubject(Cookies.get("jwtToken"));
let expirationLogout;

export const authenticationService = {
  logout,
  login,
  checkAction,
  startTimeout,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  }
};

function startTimeout(expiration) {
  let timeout = expiration - Date.now();
  expirationLogout = setTimeout(logout, timeout);
}

function logout() {
  // remove user from local storage to log user out
  clearTimeout(expirationLogout);
  apiCalls.logout()
  .then((_) => {
    currentUserSubject.next(null);
    window.location.replace(`${window.location.origin}/#/login`);
    sessionStorage.removeItem("selectedTimetable");
    sessionStorage.removeItem("ConfigurationManagerApplication");
  });
}

async function login(username, password) {
  return await apiCalls.authUser(username, password)
    .then((result) => { return result.landingPage })
}

function checkAction(location='/', action){
  return apiCalls.checkPermissionAction(location, action)
}
